/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import OauthClientAppModel from './Model';

export default class ClientApp extends React.Component<{ app: OauthClientAppModel }> {
    render() {
        return (
            <div>
                <div className="apmui-webtop-resource--caption-container">
                    <span className="apmui-webtop-resource--icon">
                        <img src={this.props.app.logoImage} alt="" />
                    </span>
                    <span className="apmui-webtop-resource--caption">{this.props.app.caption}</span>
                </div>
                <div className="apmui-page-oauth-authz--description">{this.props.app.description}</div>
            </div>
        );
    }
}
